import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthShell from '../components/auth-shell.tsx';
import { useDocumentTitle } from '../hooks/index.ts';
import { SUPPORT_EMAIL } from '@shared/ai-disclosure.ts';

/**
 * Public account-deletion page.
 *
 * There is no unauthenticated email-token flow. Google Play's web resource
 * is this page: it tells the person to sign in and use Settings, or to email
 * support. Payment records are kept, anonymized, either way.
 */
export default function DeleteAccountPage() {
  const { t } = useTranslation();
  useDocumentTitle(t('deleteAccount.public.documentTitle'));
  const email = SUPPORT_EMAIL;

  return (
    <AuthShell title={t('deleteAccount.public.title')} subtitle={t('deleteAccount.public.subtitle')}>
      <div className="flex flex-col gap-4 text-sm">
        <p>{t('deleteAccount.public.body')}</p>
        <p>
          <Link to="/login" className="text-[color:var(--color-brand)] hover:underline">
            {t('deleteAccount.public.signIn')}
          </Link>
        </p>
        <p>
          <a className="text-[color:var(--color-brand)] hover:underline" href={`mailto:${email}`}>
            {email}
          </a>
        </p>
        <p className="text-[color:var(--color-muted)]">{t('deleteAccount.public.retention')}</p>
      </div>
    </AuthShell>
  );
}
